import { axios, axios2 } from '@/lib/axios';

export type SocialLoginDTO = {
  provider: string;
  social_id: string;
  first_name: string;
  last_name: string;
  dob: string;
  email: string;
};

export const socialLogin = (data: SocialLoginDTO) => {
  return axios2.post('/customer-api/social-login', data);
};
